import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {formatCurrency} from '../utils/currency';
import Loading from './Loading';

class ItemCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRendered: false,
      perPage: props.isSmall ? 3 : 5,
    };
  }

  shouldComponentUpdate() {
    return !this.state.isRendered;
  }

  render() {
    if (this.props.isFetching) {
      return (<Loading/>);
    }

    this.setState({ isRendered: true });

    setTimeout(() => {
      if (!window.$) {
        return;
      }

      $('.item-carousel__list').each(function(){
        const $images = $(this).find('.item-carousel__item__image'),
          totalImages = $images.length;
        let loadedImages = 0,
          maxHeight = 0;

        $images.each(function(){
          $(this).find('img').one('load', function() {
            maxHeight = Math.max(maxHeight, $(this).height());
            if (++loadedImages === totalImages) {
              $images.height(maxHeight);
            }
          }).each(function() {
            if(this.complete) $(this).trigger('load');
          });
        });
      });

      if (window.initCarousels) {
        window.initCarousels();
      }
    }, 100);

    const items = this.props.items || [];

    return items.length ?
      (
        <div className={`row column item-carousel ${this.props.isSmall ? '-small' : ''}`}>
          <h2>{this.props.title}</h2>

          <div className="item-carousel__container">
            <div className="item-carousel__list" data-equalizer="data-equalizer" data-per-page={this.state.perPage}>
              {items.map(product =>
                <div key={product.id} className="item-carousel__item">
                  <a className="item-carousel__item__image" data-equalizer-watch="data-equalizer-watch" href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                    <img src={`${ROOT_URL}/uploads/products/${product.image}`} />
                  </a>
                  <div className="item-carousel__item__details">
                    {
                      !product.callForPricing &&
                      <span className="item-carousel__item__price">{formatCurrency(product.salePrice || product.price)}</span>
                    }
                    {
                      product.remainingStock > 0 && !product.isDiscontinued && !product.isComingSoon && !product.callForPricing &&
                      <a onClick={e => this.props.onAddToCart(product)} className="item-carousel__item__button button tiny primary">Add to cart</a>
                    }
                  </div>
                  <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                    <span className="item-carousel__item__title" dangerouslySetInnerHTML={{__html: product.name}}/>
                  </a>
                </div>
              )}
            </div>
            <Loading/>
          </div>

        </div>
      )
      : null;
  }
}

ItemCarousel.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  isSmall: PropTypes.bool
};

export default ItemCarousel;
